import { t } from "@lingui/core/macro";

import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

import { PunchPassListItem } from "./PunchPassListItem";
import { PunchPassListItem_PunchPass$key } from "./__generated__/PunchPassListItem_PunchPass.graphql";

export type UnavailablePunchPassesSectionProps = {
  punchPassRefs: readonly PunchPassListItem_PunchPass$key[];
};

export const UnavailablePunchPassesSection = ({
  punchPassRefs,
}: UnavailablePunchPassesSectionProps) => {
  if (punchPassRefs.length === 0) {
    return null;
  }

  return (
    <VStack gap={2} padding={5} backgroundColor="surface-primary">
      <Text
        variant="mainTiny"
        color="text-secondary"
        fontWeight="semibold"
        paddingVertical={1}
      >{t`UNAVAILABLE`}</Text>
      {punchPassRefs.map((ref, index) => (
        <PunchPassListItem
          key={index}
          punchPassRef={ref}
          isAvailable={false}
          isApplied={false}
          onApply={() => {}}
          onRemove={() => {}}
        />
      ))}
    </VStack>
  );
};
